import type { StateCreator } from 'zustand';
import type { AppStore, WhiteboardSlice, WhiteboardElement, WhiteboardState } from '../types';

const initialWhiteboardState: Omit<WhiteboardSlice, keyof import('../types').WhiteboardActions> = {
  elements: [],
  selectedElementId: null,
  zoom: 1,
  panX: 0,
  panY: 0,
  isDrawing: false,
  tool: 'select',
};

export const createWhiteboardSlice: StateCreator<AppStore, [], [], WhiteboardSlice> = (set) => ({
  ...initialWhiteboardState,

  addElement: (element: WhiteboardElement) =>
    set((state) => ({
      elements: [...state.elements, element],
    })),

  updateElement: (id: string, updates: Partial<WhiteboardElement>) =>
    set((state) => ({
      elements: state.elements.map((element) =>
        element.id === id ? { ...element, ...updates } : element
      ),
    })),

  removeElement: (id: string) =>
    set((state) => ({
      elements: state.elements.filter((element) => element.id !== id),
      selectedElementId: state.selectedElementId === id ? null : state.selectedElementId,
    })),

  selectElement: (id: string | null) =>
    set({ selectedElementId: id }),

  setZoom: (zoom: number) =>
    set({ zoom: Math.max(0.1, Math.min(5, zoom)) }),

  setPan: (panX: number, panY: number) =>
    set({ panX, panY }),

  setTool: (tool: WhiteboardState['tool']) =>
    set({ tool }),

  setIsDrawing: (isDrawing: boolean) =>
    set({ isDrawing }),

  clearWhiteboard: () =>
    set({
      elements: [],
      selectedElementId: null,
    }),
});
